module.exports = __webpack_public_path__ + "static/media/karl-gylleus.1de4b46a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/member-photos/karl-gylleus.jpg
// module id = 209
// module chunks = 0